import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CSSModules from 'react-css-modules';
import { Text, TextPreset, Color } from '@pegasus/ui-components/components/text';

import styles from './Tab.scss';

export class Tab extends PureComponent {
    static propTypes = {
        index: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        active: PropTypes.bool.isRequired,
        onAction: PropTypes.func.isRequired
    }

    render() {
        const { active, name } = this.props;

        return (
            <li onClick={this.handleAction} styleName={classNames('tab', { active })}>
                <Text preset={TextPreset.XS_BOLD} color={Color.dark}>
                    {name}
                </Text>
            </li>
        );
    }

    handleAction = () => {
        const { onAction, index } = this.props;
        onAction(index);
    }
}

export default CSSModules(Tab, styles, { allowMultiple: true });
